<div class="row">
  <form class="col-12 mt-1" [formGroup]="form">
    <ng-select [items]="tasks" bindLabel="title" bindValue="id" placeholder="Task" formControlName="taskId"
      [clearable]="false" [ngClass]="{ 'is-invalid': error }" (change)="error = false">
    </ng-select>
    <span class="text-danger" *ngIf="error">Please select a task...</span>
  </form>
  <div class="col-12 d-flex align-items-center my-2">
    <div class="pr-2 d-flex justify-content-center align-items-center mars-actions-td">
      <time-tracking-button [ss]="HandlePlay" [ec]="true" [s]="started"></time-tracking-button>
    </div>
    <div>
      <h6>
        {{ time ? time : "00:00:00" }}
      </h6>
    </div>
  </div>
  <div class="mars-time-tracking-inner elevation" *ngIf="records.length > 0">
    <div class="table-responsive">
      <table class="table table-hover mb-0">
        <tbody>
          <tr *ngFor="let r of records; let i = index">
            <td class="mars-actions-td pr-0" [ngClass]="{ 'border-0': i == 0 }" style="width: 100px">
              <time-tracking-button [ss]="HandlePlay" [c]="pRecords[r]" [s]="started"></time-tracking-button>
            </td>
            <td class="pl-0" [ngClass]="{ 'border-0': i == 0 }">
              <div>
                <h6>{{ pRecords[r].arr[0].task ?? "---" }}</h6>
                <span class="text-muted">{{ pRecords[r].time ?? "---" }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>